'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (series, layout, dashboard, filterTitle) {
    var seriesName = series[0].name;

    var mergedTitle = seriesName + ' - ' + filterTitle;

    return {
        text: dashboard || (0, _isString2.default)(layout.title) ? mergedTitle : seriesName
    };
};

var _isString = require('d2-utilizr/lib/isString');

var _isString2 = _interopRequireDefault(_isString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=gauge.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/adapters/dhis_highcharts/subtitle/gauge.js
 ** module id = 204
 ** module chunks = 0 1
 **/